import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesRequirements} from './citizens-services-requirements.model';
import * as CitizensServicesRequirementsActions from './citizens-services-requirements.actions';

export const citizensServicesRequirementsesFeatureKey = 'citizensServicesRequirementses';

export interface State extends EntityState<CitizensServicesRequirements> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesRequirements> = createEntityAdapter<CitizensServicesRequirements>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesRequirementsActions.addCitizensServicesRequirements,
    (state, action) => adapter.addOne(action.citizensServicesRequirements, state)
  ),
  on(CitizensServicesRequirementsActions.upsertCitizensServicesRequirements,
    (state, action) => adapter.upsertOne(action.citizensServicesRequirements, state)
  ),
  on(CitizensServicesRequirementsActions.addCitizensServicesRequirementss,
    (state, action) => adapter.addMany(action.citizensServicesRequirementss, state)
  ),
  on(CitizensServicesRequirementsActions.upsertCitizensServicesRequirementss,
    (state, action) => adapter.upsertMany(action.citizensServicesRequirementss, state)
  ),
  on(CitizensServicesRequirementsActions.updateCitizensServicesRequirements,
    (state, action) => adapter.updateOne(action.citizensServicesRequirements, state)
  ),
  on(CitizensServicesRequirementsActions.updateCitizensServicesRequirementss,
    (state, action) => adapter.updateMany(action.citizensServicesRequirementss, state)
  ),
  on(CitizensServicesRequirementsActions.deleteCitizensServicesRequirements,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesRequirementsActions.deleteCitizensServicesRequirementss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesRequirementsActions.loadCitizensServicesRequirementss,
    (state, action) => adapter.setAll(action.citizensServicesRequirementss, state)
  ),
  on(CitizensServicesRequirementsActions.clearCitizensServicesRequirementss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
